<template>
    <b-modal
        v-model="isOpened"
        :title="modalTitle"
        modal-class="add-edit-team-modal"
        size="lg"
        @show="setModalData"
        @hide="clearModalData"
    >
        <div class="d-flex flex-row">
            <div class="flex-grow-1">
                <b-form-group
                    id="input-group-name"
                    label="Nome:"
                    label-for="input-name"
                >
                    <b-form-input
                        v-model="form.name"
                        id="input-name"
                        required
                        placeholder="Digite o nome da equipe"
                    />
                </b-form-group>
            </div>
        </div>
        <div class="d-flex flex-row">
            <div class="col-6 pl-0">
                <b-form-group
                    id="input-group-users"
                    label="Usuários:"
                    label-for="select-users"
                >
                    <multiselect
                        id="select-users"
                        v-model="form.users"
                        :options="users"
                        :multiple="true"
                        :close-on-select="false"
                        :clear-on-select="false"
                        :preserve-search="true"
                        :option-height="40"
                        :show-labels="false"
                        placeholder="Escolha os usuários da equipe"
                        track-by="value"
                        label="text"
                    >
                        <template slot="selection" slot-scope="{ values }">
                            <span class="multiselect__single" v-if="values.length">{{ values.length }} selecionados</span>
                        </template>
                        <template slot="option" slot-scope="props">
                            <b-avatar class="option__image" :src="props.option.img" />
                            <div class="option__desc">
                                <span class="option__title">{{ props.option.text }}</span>
                            </div>
                        </template>
                    </multiselect>
                </b-form-group>
                {{ teamUsers.join(', ') }}
            </div>
            <div class="col-6 pl-0">
                <b-form-group
                    id="input-group-users"
                    label="Gestor:"
                    label-for="select-manager"
                >
                    <multiselect
                        id="select-manager"
                        v-model="form.manager"
                        :options="managers"
                        :clear-on-select="false"
                        :preserve-search="true"
                        :option-height="54"
                        :show-labels="false"
                        placeholder="Escolha o gestor da equipe"
                        track-by="value"
                        label="text"
                    >
                        <template slot="singleLabel" slot-scope="props">
                            <b-avatar class="option__image" :src="props.option.img" />
                            <span class="option__desc">
                                <span class="option__title">{{ props.option.text }}</span>
                            </span>
                        </template>
                        <template slot="option" slot-scope="props">
                            <b-avatar class="option__image" :src="props.option.img" />
                            <div class="option__desc">
                                <span class="option__title">{{ props.option.text }}</span>
                            </div>
                        </template>
                    </multiselect>
                </b-form-group>
            </div>
        </div>
        <div slot="modal-footer">
            <b-btn
                @click="clearModalData"
                variant="secondary"
            >
                Cancelar
            </b-btn>
            <b-btn
                @click="!modalData ? createTeam() : editTeam()"
                variant="primary"
                class="ml-2"
            >
                Salvar
            </b-btn>
        </div>
    </b-modal>
</template>

<script>
import Multiselect from 'vue-multiselect'
require('vue-multiselect/dist/vue-multiselect.min.css')

export default {
    name: 'AddEditTeam',
    components: {
        Multiselect,
    },
    data () {
        return {
            form: {
                name: '',
                users: [],
                manager: [],
            },
            users: [],
            userToAdd: 0,
            managers: [],
        }
    },
    methods: {
        loadUsers () {
            this.$store
                .dispatch('auth/loadUsers')
                .then(() => {
                    let listUsers = []
                    this.$store.getters['auth/users'].forEach((user) => {
                        listUsers.push({
                            value: user.uid,
                            text: user.displayName,
                            img: user.photoURL || '',
                        })
                    })
                    listUsers = listUsers.sort((a, b) => {
                        if (a.text > b.text) {
                            return 1
                        }

                        if (a.text < b.text) {
                            return -1
                        }

                        return 0
                    })

                    this.users = listUsers
                    this.managers = listUsers
                })
        },
        createTeam () {
            const data = { form: this.form }
            this.$store
                .dispatch('team/createTeam', data)
                .then(() => {
                    console.log('%c%s:%i', 'color: darkgreen', 'AddEditTeam.vue', 121)
                    this.isOpened = false
                })
        },
        editTeam () {
            const data = {
                uid: this.uid,
                form: this.form,
            }

            this.$store
                .dispatch('team/editTeam', data)
                .then(() => {
                    console.log('%c%s:%i', 'color: darkgreen', 'AddEditTeam.vue', 130)
                    this.isOpened = false
                })
        },
        setModalData () {
            if (!this.modalData) return

            const { uid, name, manager, users } = this.modalData

            this.uid = uid
            this.form.name = name
            this.form.manager = manager
            this.form.users = users
        },
        clearModalData () {
            this.isOpened = false
            this.$store.dispatch('modals/setData', { key: 'addEditTeamData', data: null })
        },
        addUserToTeam () {
            this.form.users.push(this.userToAdd)
            this.users = this.users.filter(user => !this.form.users.includes(user.value))
        },
    },
    computed: {
        modalData () {
            return this.$store.getters['modals/getProperty']('addEditTeamData')
        },
        modalTitle () {
            return !this.modalData ? 'Adicionar Equipe' : 'Editar Equipe'
        },
        isOpened: {
            get () {
                return this.$store.getters['modals/isOpened']('addEditTeam')
            },
            set () {
                return this.$store.dispatch('modals/close', 'addEditTeam')
            },
        },
        teamUsers () {
            return this.form.users.map((user) => {
                return user.text
            }).sort()
        },
    },
    created () {
        this.loadUsers()
    },
}
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<style lang="scss">
.option__desc{
    display: inline-block;
    vertical-align: middle;
}

.option__image {
    max-height: 30px;
    max-width: 30px;
    margin-right: 10px;
}

.multiselect__option--selected {
    background: #cccccc;

    > .multiselect__option--highlight {
        background: #ff6a6a;
    }
}

</style>
